import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IQuota } from '../../models/IQuota';
import { IQuotaTable } from '../../models/IQuotaTable';
import { Observable } from 'rxjs/Observable';
import { IQuestion } from '../../models/IQuestion';
import { IS1Question } from '../../models/IS1Question';
import { IS1Answer } from '../../models/IS1Answer';
import { S1DataService} from '../../services/s1data.service';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { IAnswer } from '../../models/IAnswer';
import { ITotalKey } from '../../models/ITotalKey';
import { NgbModule, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Utils } from '../../Utils'
import { ITextItem } from '../../models/ITextItem';
import { FeasibilityCheckSupplierMode } from '../../enums/feasibility-check-supplier-mode.enum';
import { debug } from 'util';
import { ISample } from '../../models/ISample';
import { NatRepServiceService } from '../../services/nat-rep-service.service';
import { ITarget } from '../../models/ITarget';
import { IQuotaIRSampleSpec } from '../../models/IQuotaIRSampleSpec';
import { QuotaIRService } from '../../services/genpop-quota-ir.service';
import { QuestionAnswerService } from '../../services/question-answer-service';

@Component({
  selector: 'quota-viewer',
  templateUrl: './quota-viewer.component.html',
  styleUrls: ['./quota-viewer.component.css']
})
export class QuotaViewerComponent implements OnInit, OnChanges {
  @Input() quotaTables: Array<IQuotaTable>;
  @Input() locales: Array<string>;
  @Input() showCompletes: boolean; //show the available count
  @Input() showNatRepPercentage: boolean; //show the nat rep percentages
  @Input() showRequested: boolean = true;  //show the request percentages
  @Input() showClicks: boolean;  //show the request percentages
  @Input() showNullCompletes: boolean = false;
  @Input() showBlendCompletes: boolean = false;
  @Input() editMode: boolean;
  @Input() sample: ISample;
  @Input() overlapLablesMap: Map<string, [string, string]>;    //dictionay of ids to [name,country]
  @Input() hoursInField: number;
  @Input() flexibleFieldDuration: boolean;
  @Input() showGenPop: boolean; //show the nat rep percentages
  @Input() targets: Array<ITarget>;
  @Input() countryCode: string;
  @Output() onQuotaTotalChanged = new EventEmitter<ITotalKey>();
  completeLabels: string[];
  quotas: Array<IQuota>;
  overlapLablesList: ITextItem[];
  tableForQuota: Map<string, string>;

  genpopIR: [number, number, boolean][] = [];// 
  showQuotaGenPopIRToggle: boolean = false;//show hide the gen pop UI controls
  genPopErrors: string = null; 
  hasGenPopIR: boolean = false;//have any results to show?
  genPopLoadingQuotaLevel: boolean = false;
  genPopLoadingQuick: boolean = false;
  
  constructor(private quotaIRService: QuotaIRService, private questionAnswerService: QuestionAnswerService) {
    this.completeLabels = [];
  }

  get locale(): string {
    return (this.locales || []).length > 0 ? this.locales[0] : "";
  }

  ngOnInit() {
    this.setup();
  }

  ngOnChanges(changes) {
    this.setup();
  }

  setup() {
    var quotas = [];
    this.tableForQuota = new Map<string, string>();
    var overlapLablesList: ITextItem[] = [];//list off the overlap (id,name) tuples
    if (this.locales.length > 0 && this.quotaTables && this.quotaTables.length > 0) {

      for (let qt of this.quotaTables)
        for (let q of qt.quotas) {
          quotas.push(q);
          this.tableForQuota[q.quotaName] = qt.tableName;
        }
      for (let id in this.overlapLablesMap) {
        var [name, countryCode] = this.overlapLablesMap[id];
        if (countryCode == this.sample.countryCode)
          overlapLablesList.push(new ITextItem(id, name));
      }
      overlapLablesList = overlapLablesList.sort((x, y) => {
        if (x.id == y.id)
          return 0;
        if (this.sample.feasibilityId === x.id)
          return -1;
        if (this.sample.feasibilityId === y.id)
          return 1;
        if (x.name < y.name) { return -1; }
        if (x.name > y.name) { return 1; }
        return 0;
      });
      if (overlapLablesList.length < 2)
        overlapLablesList = [];//if we have only one subsample for this country, we don't need to show a list at all.

      this.overlapLablesList = overlapLablesList;
      this.quotas = quotas;
      this.completeLabels = this.showCompletes ? Utils.HoursToFieldDurLables(this.hoursInField, this.flexibleFieldDuration) : [];
      if (this.showCompletes) {
        for (let qt of this.quotaTables) {
          for (let q of qt.quotas) {
            q.completes = (q.completes || {});
            q.nullCompletes = (q.nullCompletes || {});
            for (let key of this.completeLabels) {
              q.completes[key] = q.completes[key] || 0;
              q.nullCompletes[key] = q.nullCompletes[key] || 0;
              if (q.nullCompletes[key] > 0)
                this.showNullCompletes =  true;
            }
          }
        }
        //dedup duplicates, I got all the labels for each quota table, I really only needed the first with 
        this.completeLabels = this.completeLabels.filter((x, i, a) => x && a.indexOf(x) === i);
        this.completeLabels.sort(Utils.sortCompleteLabels);
      }
      this.setUnsupportedVarsList();

    }
  }

  quotaCount(quota: IQuota, fezaId: string): number {
    for (let id in quota.overlap) {
      if (id === fezaId)
        return quota.overlap[fezaId];
    }
    return null;
  }

  onTotalChanged(label: string, quotaIndex: number) {
    const itot: ITotalKey = { value: this.quotas[quotaIndex].completes[label], totalKey: label };
    this.onQuotaTotalChanged.emit(itot);
  }

  setUnsupportedVarsList(checkedListOfAnswerIds: number[] = []) {
    this.genpopIR = [];
    var questionsIds = new Set<number>();
    for (let t of (this.targets || [])) {
      for (let que of (t.questions || [])) {
        if (que.id > 0) {
          for (let ans of (que.answers || [])) {
            if (!questionsIds.has(que.id)){
              this.genpopIR.push([que.id, ans.id, checkedListOfAnswerIds.includes(ans.id)]);
              questionsIds.add(que.id);
            }
          }
        }
      }
    }
    for (let qt of (this.quotaTables || [])) {
      for (let q of qt.quotas) {
        for (let que of q.questions) {
          if (que.id > 0) {
            for (let ans of (que.answers || [])) {
              if (!questionsIds.has(que.id)) {
                this.genpopIR.push([que.id, ans.id, checkedListOfAnswerIds.includes(ans.id)]);
                questionsIds.add(que.id);
              }
            }
          }
        }
      }
    }
  }

  checkedIrQuestion(q: IQuestion): boolean {
    //check if this item is checked. 
    for (let [qid, _, checked] of Array.from(this.genpopIR)) {
      if (qid === q.id && checked == true) {
        return true;
      }
    }
    return false;
  }

  getUnsupportedVarsList(): IQuestion[] {
    let questionList: IQuestion[] = [];
    for (let t of (this.targets || [])) {
      for (let que of (t.questions || [])) {
        if (que.id > 0) {
          if (this.checkedIrQuestion(que))
            questionList.push(que);
        }
      }
    }
    for (let qt of (this.quotaTables || [])) {
      for (let q of qt.quotas) {
        for (let que of q.questions) {
          if (que.id > 0) {
            if (this.checkedIrQuestion(que))
              questionList.push(que);
          }
        }
      }
    }
    return questionList;
  }


  setGenPopLoadingLabel(quick: boolean, val: boolean) {
    if (quick == true)
      this.genPopLoadingQuotaLevel = val;
    else
      this.genPopLoadingQuick = val;
  }

  onGenPopClicked(quick: boolean) {
    this.setGenPopLoadingLabel(quick, true);
    this.genPopErrors = "";
    this.hasGenPopIR = false;
    var hasNoVarsSelected: boolean = this.getUnsupportedVarsList().length === 0;
    var spec: IQuotaIRSampleSpec =
      {
        countryCode: this.countryCode,
        countryCultures: this.locales,
        quotaTables: this.quotaTables,
        target: this.targets,
        underPopulatedQuestions: this.getUnsupportedVarsList(),
        fieldDurations: Utils.HoursToFieldDurLables(this.hoursInField, this.flexibleFieldDuration)
      } as IQuotaIRSampleSpec;
    this.quotaIRService.GenPopIRWithUnsupportedVars(quick, spec).subscribe(res => {
      this.setGenPopLoadingLabel(quick, false);
      if (res.errors.length === 0) {
        for (let qt of (res.quotaTables || [])) {
          for (let specQuota of (qt.quotas || [])) {
            var viewerQuota = this.getViewerTableQuota(specQuota.quotaId);
            viewerQuota.genPopIncidence = specQuota.genPopIncidence;
            if (hasNoVarsSelected && res.underPopulatedVariables) {
              //the user didn't pick any, so lets update the check boxes for them!
              this.setUnsupportedVarsList(res.underPopulatedVariables.map(v => v.standardQuestionAnswerId));
            }

          }
        }
        this.hasGenPopIR = true;
      }
      else {
        this.genPopErrors = res.errors.join(",");
      }
    }, err => {
        this.setGenPopLoadingLabel(quick, false);
        this.hasGenPopIR = false;
        if (err.error && err.error.errors)
          this.genPopErrors = `${Utils.getErrorDetailsString(err)}`;
        else {
          this.genPopErrors = `Something didn't work right in /quota IR service call.`;
          console.log(err);
        }
    });
  }

  getViewerTableQuota(quotaId: string) {
    for (let qt of (this.quotaTables || [])) {
      for (let quota of (qt.quotas || [])) {
        if (quota.quotaId.toLowerCase() == quotaId.toLowerCase())
          return quota;
      }
    }
    return { quotaId: quotaId } as IQuota;//fake one.
  }
}



// WEBPACK FOOTER //
// ./src/app/components/quota-viewer/quota-viewer.component.ts